import { Dialog, DialogTitle, DialogActions, DialogContent, DialogProps } from '@mui/material';
import React from 'react';

export interface DialogPage {
    number: number;
    params?: string;
    available: number;
}

const CustomDialog = (props: DialogProps) => (
    <Dialog
        // {...props} must come first so the onClose handler overrides the default MUI behaviour.
        // Due to recent MUI changes, this order is required to prevent the dialog from closing when clicking the
        // backdrop.
        {...props}
        onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
                props.onClose && props.onClose(event, reason);
            }
        }}
        disableEnforceFocus
    />
);

export { Dialog, CustomDialog, DialogTitle, DialogActions, DialogContent };
